<template>
  <div class="eb-content-default">
    <div class="text-right md:flex md:justify-between md:align-items-center">
      <EbHeading level="h1" class="eb-page-heading">Liste des assistants maternels</EbHeading>
    </div>
    
    <div>
      <p class="text-italic">
        Téléchargez la liste de tous les assistants maternels agréés sur le territoire d'une commune, y compris les assistants maternels en Arrêt temporaire d'activité (ATA, par exemple : arrêt maladie, congé maternité… etc) correspondant à un agrément en cours de validité mais non utilisé, et les assistants maternels en suspension d'agrément.
      </p>
      <form @submit.prevent="submitForm">
        <div class="eb-select eb-select-inline">
          <EbLabel text="Commune" for="city"></EbLabel>
          <select id="city" class="eb-select-solid" required>
            <option value="" selected disabled>Choisissez la commune</option>
            <option v-for="result in resultsCommunes" :value="result.id" :data-insee="result.codeInsee" :data-deleguee="result.codeInseeNouvelle ? true : false">
              {{ result.libelle }}
              <span v-if="result.idCommuneNouvelle" v-text="getCommuneNouvelle(result)"></span>
            </option>
          </select>
        </div>
        <EbButton withIcon="icon-before" @click="exportType = 'pdf'" type="submit">
          <font-awesome-icon :icon="['fas', 'file-pdf']" size="lg" />
          Télécharger la liste en PDF
        </EbButton>
        <EbButton withIcon="icon-before" @click="exportType = 'csv'" type="submit">
          <font-awesome-icon :icon="['fas', 'file-csv']" size="lg" />
          Télécharger la liste en CSV
        </EbButton>
        
      </form>
      
      <div v-if="errored">
        {{ errorMessage }}
      </div>
      
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      resultsCommunes: [],
      exportType: "",
      errored: false,
      errorMessage: ''
    }
  },
  mounted() {
    this.$http
    .get('/authentification/isAuthenticated')
    
    this.$http
    .get('export/communes')
    .then((result) => {
      this.resultsCommunes = result.data;
    })
    .catch((error) => {
      console.log(error);
      this.errored = true;
    });
  },
  methods: {
    submitForm: function () {
      
      this.$http
      .get('export/partenaire/' + this.exportType, {
        responseType: 'blob',
        params: {
          idCommune: city.options[city.selectedIndex].value
        }
      })
      .then((response) => {
        if (response.status == 204) {
          this.errored = true;
          this.errorMessage = 'Il n’y a pas d’assistants maternels dans cette commune';
        } else {
          this.errored = false;
          let url = URL.createObjectURL(new Blob([response.data])),
          cityName = city.options[city.selectedIndex].text.replace(/ /g, '_'),
          a = document.createElement('a');
          a.href = url;
          a.download = 'Liste_Assistants_Maternels_' + cityName + '.' + this.exportType;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        }
      })
      .catch((error) => {
        console.debug(error);
        this.errorMessage = error;
        this.errored = true;
      });
    },
    getCommuneNouvelle: function (commune) {
      let communeNouvelle = '';
      this.resultsCommunes.forEach((c) => {
        if (c.id == commune.idCommuneNouvelle) {
          communeNouvelle = '(' + c.libelle + ')';
          return;
        }
      });
      return communeNouvelle;
    }
  }
}
</script>